module.exports = __webpack_public_path__ + "img/inheritance.c9308bc6.png";